<template>
    <div class="page">
        <div class="day">{{ days }}</div>
        <div class="container" v-if="signInfo.length > 0">
            <div class="row">
                <div class="item" v-for="(item, index) in signInfo.slice(0, 4)" :key="index">已签到</div>
            </div>
        </div>
        <div class="second-row" v-if="signInfo.slice(4).length > 0">
            <div class="row">
                <div class="item" v-for="(item, index) in signInfo.slice(4)" :key="index + 4">已签到</div>
            </div>
        </div>
        <div class="btn">
            <div @click="qdClick">签到</div>
            <div @click="onClick">积分</div>
        </div>
        <div class="jb">已获得<span>{{ signCount }}</span>积分</div>
        <van-dialog v-model:show="show" title="兑换积分" show-cancel-button @confirm="confirm">
            <input class="input" type="number" placeholder="请输入积分" v-model="amount" />
        </van-dialog>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Toast, Dialog } from 'vant';
export default {
    name: 'appQian',
    data() {
        return {
            show: false,
            iccid: '',
            amount: null,
            days: 0,
            signInfo: [],
            signCount: 0,
        };
    },
    mounted() {
        if (this.$route.query.iccid) {
            this.iccid = this.$route.query.iccid;
            this.signInfo = []
            this.getSignInfo();
        } else {
            Toast.fail('卡号丢失！');
        }

    },
    methods: {
        onClick() {
            this.show = true;
        },
        //*获取签到信息*/
        getSignInfo() {
            wxRequest("order/app/qian/select", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == 200) {
                    this.signCount = res.data.data.totalNum
                    this.days = res.data.data.totalDay
                    for (let i = 1; i < res.data.data.totalDay + 1; i++) {
                        this.signInfo.push(i)
                    }
                } else {
                    Toast.fail(res.data.message);
                }

            })
        },
        //*签到*/
        qdClick() {
            wxRequest("order/app/qian/add", { iccid: this.iccid }, "post").then(res => {
                if (res.data.code == 200) {
                    this.getSignInfo();
                    Dialog.alert({
                        title: "提示",
                        message: '签到成功！',
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }

            })
        },
        confirm() {
            //*兑换积分*/
            if (this.amount == null || !this.amount) {
                Toast.fail('请输入积分');
                return;
            }
            wxRequest("order/add/qian/pkg", { iccid: this.iccid, amount: this.amount }, "post").then(res => {
                if (res.data.code == 200) {
                    this.getSignInfo();
                    Dialog.alert({
                        title: "提示",
                        message: '兑换成功！',
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            })
        }
    },
};
</script>
<style scoped lang="less">
.page {
    background: url('~@/assets/img/5113201.png') no-repeat top center;
    background-size: 100% 100%;
    height: 100%;
    padding: 0 20px;
    position: relative;

    .day {
        position: absolute;
        top: 40%;
        left: 59%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        color: red;
        text-align: center;
        line-height: 1.2;
        font-weight: bold;
        font-family: 'PingFangSC-Medium', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }

    .container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 20px;
        /* 设置行间距 */
        top: 59%;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        width: 80%;
    }

    .row {
        display: flex;
        gap: 38px;
        /* 设置列间距 */
    }

    .second-row {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 20px;
        /* 设置行间距 */
        top: 73%;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        width: 60%;
    }

    .item {
        /* flex: 1; */
        width: 50px;
        background-color: #f0f0f0;
        padding: 4px 0;
        text-align: center;
        font-size: 10px;
        border: 1px solid #ccc;
        border-radius: 20px;
    }

    .jb {
        position: absolute;
        top: 82.5%;
        left: 52%;
        transform: translate(-50%, -50%);
        color: #777;
        text-align: center;
        line-height: 1.2;
        font-size: 14px;
        font-family: 'PingFangSC-Medium', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        span{
            font-weight: bold;
            font-size: 18px;
            padding:0 6px;
            color: red;
        }
    }

    .btn {
        position: absolute;
        top: 78%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: space-between;
        width: 80%;
        text-align: center;
        font-family: 'PingFangSC-Medium', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;

        div {
            background: #f4b625;
            color: #fff;
            padding: 12px 0;
            width: 110px;
            text-align: center;
            border-radius: 20px;
        }
    }
}

::v-deep .van-dialog__content {
    text-align: center;
}

.input {
    width: 70%;
    height: 30px;
    font-size: 12px;
    border-radius: 6px;
    border: 1px solid #ccc;
    padding: 0 10px;
    margin: 10px auto;
}
</style>